import { render } from "./SiteAnnouncementDialog.vue?vue&type=template&id=887dac80&scoped=true"
import script from "./SiteAnnouncementDialog.vue?vue&type=script&lang=js"
export * from "./SiteAnnouncementDialog.vue?vue&type=script&lang=js"

import "./SiteAnnouncementDialog.vue?vue&type=style&index=0&id=887dac80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-887dac80"]])

export default __exports__